/** Filtros de fila do Inbox aceitos via `?filter=` (HJ-02 / Vision). */
export const CHAT_LINK_FILTERS = [
  'all',
  'unread',
  'ai-attending',
  'needs-human',
  'awaiting',
  /** Silêncio longo (~4+ dias) — alinhado à heurística risk_silent do today-v2. */
  'risk-silent',
  'archived',
  'favorites',
  'whatsapp-groups',
] as const;

export type ChatLinkFilter = (typeof CHAT_LINK_FILTERS)[number];

export function isChatLinkFilter(value: string | null | undefined): value is ChatLinkFilter {
  return !!value && (CHAT_LINK_FILTERS as readonly string[]).includes(value);
}

export function readChatLink(search: string): {
  contactId: number | null;
  draft: string | null;
  filter: ChatLinkFilter | null;
} {
  const rawSearch = search.startsWith('?') || search.length === 0 ? search : `?${search}`;
  const params = new URLSearchParams(rawSearch);
  const rawId = params.get('contactId');
  const id = rawId == null || rawId === '' ? NaN : parseInt(rawId, 10);
  const draft = params.get('draft');
  const rawFilter = params.get('filter');
  return {
    contactId: Number.isFinite(id) ? id : null,
    draft: draft && draft.trim() ? draft : null,
    filter: isChatLinkFilter(rawFilter) ? rawFilter : null,
  };
}
